<p-toolbar id="app-header" class="app-header" [class.sidebar-expanded]="!isSidebarCollapsed()">
    <header class="no-print">
        <div class="p-toolbar-group-left screen-lg">
            <div class="row">
                @if (currentUser()?.firstName) {
                    <div id="header-welcome-message">
                        {{ welcomeMessage() | translate }},
                        <span id="header-user-first-name"
                            >{{ currentUser()?.firstName ? currentUser()?.firstName : null }}!</span
                        >
                    </div>
                } @else {
                    <div id="header-welcome-message">{{ welcomeMessage() | translate }}!</div>
                }
            </div>
        </div>

        <div class="p-toolbar-group-left screen-sm">
            <div id="sidebar-header-logo">
                <a [routerLink]="'/'" aria-label="Go to dashboard">
                    <img
                        ngSrc="images/app-logo.svg"
                        id="app-logo"
                        alt="The application logo and redirects to the dashboard"
                        height="40"
                        width="40" />
                </a>
                <div>
                    <h1 id="app-title-header">Colony Admin</h1>
                    <h2 id="app-subtitle-header">Transnetyx</h2>
                </div>
            </div>
        </div>

        <div class="no-print">
            <app-toolbar></app-toolbar>
        </div>
    </header>
</p-toolbar>
